<template>
  <UiBaseIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    class="icon"
  >
    <g clip-path="url(#clip0_36434_24943)">
      <rect
        width="32"
        height="32"
        rx="16"
        fill="#C1D1E3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.604 27.2307C5.74911 23.7667 8.4295 21.0015 11.8393 19.741C9.82602 18.3961 8.50009 16.1029 8.50009 13.5C8.50009 9.35786 11.8579 6 16.0001 6C20.1422 6 23.5001 9.35786 23.5001 13.5C23.5001 16.1029 22.1742 18.3961 20.1609 19.741C23.5707 21.0015 26.2511 23.7667 27.3962 27.2307C26.8771 27.7574 26.3217 28.2483 25.7342 28.6994C24.6949 24.2855 20.7312 21 16.0001 21C11.269 21 7.30524 24.2855 6.26601 28.6994C5.67846 28.2483 5.12311 27.7574 4.604 27.2307ZM16.0001 19C19.0377 19 21.5001 16.5376 21.5001 13.5C21.5001 10.4624 19.0377 8 16.0001 8C12.9625 8 10.5001 10.4624 10.5001 13.5C10.5001 16.5376 12.9625 19 16.0001 19Z"
        fill="#9DB2CA"
      />
    </g>
    <defs>
      <clipPath id="clip0_36434_24943">
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
